import { Breadcrumb, Button, Col, Form, Input, Row, Select } from "antd";
import styles from "./search.module.scss";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { validateInput } from "../../../tools/tools";
import ReactInputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { useAPIPublic, useDealer } from "../../../tools/api";
import { useNavigate } from "react-router-dom";
const Search360 = () => {
	const [t] = useTranslation("global");
	const [frmService] = Form.useForm();
	const nav = useNavigate();

	const { validateMSISDNVCertNO } = useDealer();
	const { queryCertType } = useAPIPublic();

	const [isSearch, setIsSearch] = useState({
		isProgress: false,
		certType: [],
		certTypeValue: null,
	});

	useEffect(() => {
		const callServCertType = async () => {
			let response = await queryCertType();
			if (response) {
				setIsSearch((s) => ({ ...s, certType: response }));
			}
		};
		callServCertType();
	}, []);

	const handleSubmit = async (values) => {
		try {
			setIsSearch((s) => ({ ...s, isProgress: true }));
			const payload = {
				msisdn: values?.smsmobile?.toString()?.replace(/ /g, ""),
				certno: values.certno,
			};
			if (values.certtype == 0) {
				const response = await validateMSISDNVCertNO(payload);
				if (response && !response.HasError) {
					nav(_adr.Root + _adr.Services360.Index + _adr.Services360.List, {
						state: {
							certno: payload.certno,
							msisdn: payload.msisdn,
							certtype: values?.certtype,
						},
					});
				}
			} else {
				nav(_adr.Root + _adr.Services360.Index + _adr.Services360.List, {
					state: {
						certno: values?.certno,
						msisdn: values?.smsmobile?.toString()?.replace(/ /g, ""),
						certtype: values?.certtype,
					},
				});
			}

			setIsSearch((s) => ({ ...s, isProgress: false }));
		} catch (error) {
			console.log(error);
			setIsSearch((s) => ({ ...s, isProgress: false }));
		}
	};
	return (
		<>
			<div className={`container-main ${styles.container_360}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("services360.title") }]} />
					<div className="title-page">
						<h3>{t("services360.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.service360_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<Form id="frmService" name="frmService" layout="vertical" form={frmService} onFinish={handleSubmit}>
									<Row>
										<Col span={12}>
											<div className={styles.notemessage}>شماره موبایل و کدملی کاربر را وارد نمایید</div>
										</Col>
									</Row>
									<Row gutter={17}>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<Form.Item className="input-normal" name="certtype" rules={[validateInput({ t: t, validate: true })]} label="نوع مدرک شناسایی">
												<Select
													onChange={(value) => setIsSearch((s) => ({ ...s, certTypeValue: value }))}
													// disabled={isValidCert ? true : false}
													// defaultValue={isPromotionTypeOneMonth ? (certType?.length > 0 ? certType[0].value : "") : ""}
												>
													{isSearch.certType.map((item, key) => (
														<Select.Option key={key} value={item.value}>
															{item.name}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<Form.Item
												className="input-normal"
												name="smsmobile"
												label="شماره موبایل"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "msisdnOrg",
													}),
												]}
												hasFeedback>
												<div>
													<ReactInputMask autoComplete="off" inputMode="numeric" className="msisdn-mask" dir="ltr" mask="0\999 999 99 99" />
												</div>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<Form.Item
												className="input-normal"
												name="certno"
												label={"مدرک شناسایی"}
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: isSearch.certTypeValue == 0 ? "number" : "english",
													}),
												]}
												// extra={<span className={styles.response_message}>شماره موبایل و کدملی باید به نام یک نفر باشد</span>}
											>
												<Input dir="ltr" autoComplete="off" inputMode="numeric" maxLength={11} />
											</Form.Item>
										</Col>
										<Col span={4} xl={4} lg={6} md={15} xs={24} sm={24}>
											<br />
											<div className="holder-button">
												<Button className="btn-normal btn-green" htmlType="submit" disabled={isSearch.isProgress}>
													{isSearch.isProgress ? t("form.inProgress") : <>مرحله بعد</>}
												</Button>
											</div>
										</Col>
									</Row>
								</Form>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default Search360;
